/**
 * Global Analytics Plugin
 * Makes basic analytics tracking available on ALL pages automatically
 */

import Vue from 'vue';

// Create a lightweight global mixin for page tracking
Vue.mixin({
  mounted() {
    // Track page views automatically on every page
    this.trackPageView();
  },

  methods: {
    /**
     * Track page view for current page
     */
    trackPageView() {
      if (typeof window === 'undefined' || !window.$analytics) {
        return;
      }

      // Don't track in development if configured
      if (process.env.NODE_ENV === 'development' && process.env.DISABLE_ANALYTICS_IN_DEV === 'true') {
        return;
      }

      // Build page view data
      const pageData = {
        page_title: document.title,
        page_location: window.location.href,
        page_path: this.$route?.path || window.location.pathname,
        page_referrer: document.referrer,
        // Add route metadata if available
        page_type: this.$route?.meta?.pageType,
        page_category: this.$route?.meta?.category
      };

      // Track page view event
      window.$analytics.track('page_view', pageData);

      console.log('[Analytics] Page view tracked:', pageData.page_path);
    },

    /**
     * Generic tracking method available globally
     */
    trackEvent(eventName, eventData = {}) {
      if (typeof window === 'undefined' || !window.$analytics) {
        console.warn('[Analytics] Analytics not available for event:', eventName);
        return;
      }

      window.$analytics.track(eventName, eventData);
    },

    /**
     * Track user interactions
     */
    trackInteraction(action, category, label = null, value = null) {
      const eventData = {
        event_category: category,
        event_label: label,
        value: value
      };

      this.trackEvent(action, eventData);
    }
  }
});

export default function ({ app }) {
  // Make analytics available in Nuxt context
  app.analytics = {
    track: (eventName, eventData) => {
      if (typeof window !== 'undefined' && window.$analytics) {
        window.$analytics.track(eventName, eventData);
      }
    },
    pageView: (pageData) => {
      if (typeof window !== 'undefined' && window.$analytics) {
        window.$analytics.track('page_view', pageData);
      }
    }
  };

  console.log('[Analytics Global] Global tracking initialized');
}